import React from "react";
import { Modal, Button, Form } from "react-bootstrap";


export const StatusChangeModal = ({ show, onHide, client, onConfirm, isLoading  }) => {
    return (
        <Modal show={show} onHide={onHide} centered
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title className="fw-bold">Change Status</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p >
                Are you sure you want to change the status of <strong>{client?.clientName}</strong> to{" "}
                <strong>{client?.status === "Active" ? "Inactive" : "Active"}</strong>?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" className="px-3 py-2" onClick={onHide} disabled={isLoading}>
                    No
                </Button>
                <Button
                    variant="primary" className="px-3 py-2"
                    onClick={onConfirm}
                    disabled={isLoading}
                >
                    {isLoading ? "yes..." : "yes"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};


export const DeleteConfirmModal = ({ show, onHide, client, onConfirm, isLoading  }) => {
    const [isChecked, setIsChecked] = React.useState(false);

    React.useEffect(() => {
      if (!show) {
        setIsChecked(false); // reset when modal closes
      }
    }, [show]);
  

    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
    };

    const handleDelete = () => {
        if (isChecked) {
            onConfirm();
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered
            aria-labelledby="contained-modal-title-vcenter"
            backdrop="static"
        >
            <Modal.Header closeButton>
                <Modal.Title className="fw-bold">Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="fw-bold mb-0" >Are you sure you want to delete {client?.clientName}?</p>
                <p >
                    All engagements and documents associated with this client will be
                    permanently removed.
                </p>
                <p className="mb-0 text-light" >Please check the box below and click 'Delete' to proceed.</p>
                <Form.Check
                    type="checkbox"
                    id="delete-confirm-checkbox"
                    label="I confirm that I want to delete this client and all associated data."
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" className="px-3 py-2" onClick={onHide}  disabled={isLoading}>
                    Cancel
                </Button>
                <Button
                    variant="primary" className="px-3 py-2"
                    onClick={handleDelete}
                    disabled={!isChecked || isLoading}
                >
                    {isLoading ? "Deleting..." : "Delete"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};